import React, { useState } from 'react';
import api from '../../../../helper/util/api';

import './index.css';

export default function TncAlert(props) {
  const { onTncSent } = props;
  const [loading, setLoading] = useState(false);

  async function handleSend() {
    setLoading(true);
    try {
      const data = {
        leadId: window.__CURRENT_DEAL_ID__
      }
      const res = await api.post('/sentAcceptTnc', data);
      setLoading(false);
      if (res.status === 200) {
        alert('T&C communication sent successfully.');
        onTncSent(res.data);
      } else {
        alert('Failed to send T&C communication. Please try again.');
      }
    } catch (err) {
      alert('Failed to send T&C communication', err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="tnc-alert" role="alert" aria-live="assertive" aria-hidden="false">
      <div className="tnc-container">
        <div className="tnc-message">
          <span className="tnc-icon" aria-hidden="true">⚠️</span>
          <span className="tnc-text">
            Customer has not accepted the Terms &amp; Conditions.
          </span>
        </div>

        <div className="tnc-actions">
          <button
            className="tnc-btn-send"
            type="button"
            onClick={handleSend}
            // disabled={sending}
            aria-label="Send Terms and Conditions to user"
          >
              {loading ? 'Sending…' : 'Sent ✓'}
            {/* {sending ? 'Sending…' : status === 'sent' ? 'Sent ✓' : status === 'error' ? 'Retry' : 'Send T&C'} */}
          </button>
        </div>
      </div>
    </div>
  );
}
